"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightTheme = void 0;
var vaporwave_color_1 = __importDefault(require("@revdotcom/vaporwave-color"));
/* based on UltraTheme use. The colors are to be used in light themes. Do not use the dark mode colors in light mode. */
exports.lightTheme = {
    breakpoints: ['30em', '60em'],
    fonts: {
        body: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
        heading: '"Raleway", sans-serif',
    },
    fontSizes: [
        '0.75rem',
        '0.875rem',
        '1rem',
        '1.25rem',
        '1.5rem',
        '2.25rem',
        '3rem',
    ],
    fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    letterSpacings: {
        tight: '-0.05em',
        tracked: '0.1em',
        medium: '0.125em',
        mega: '0.17em',
    },
    lineHeights: {
        solid: 1,
        title: 1.25,
        third: 1.33,
        copy: 1.5,
    },
    space: [
        0,
        '0.25rem',
        '0.5rem',
        '1rem',
        '1.5rem',
        '2rem',
        '4rem',
        '8rem',
        '16rem',
    ],
    sizes: [
        '1rem',
        '2rem',
        '4rem',
        '8rem',
        '16rem',
        '32rem',
        '48rem',
        '64rem',
        '96rem',
    ],
    radii: [0, '0.125rem', '0.25rem', '0.5rem', '1rem', '100%', '9999px'],
    borderWidths: [0, '0.125rem', '0.25rem', '0.5rem', '1rem', '2rem'],
    shadows: [
        'inset 0 1px 3px 0 rgba(106, 106, 106, 0.15)',
        '0 0 8px 2px rgba(0, 0, 0, 0.2)',
        '2px 2px 4px 2px rgba(0, 0, 0, 0.2)',
        '10px 10px 20px 5px rgba(0, 0, 0, 0.12)',
        '14px 14px 42px 5px rgba(0, 0, 0, 0.18)',
    ],
    colors: {
        /* Brand Colors */
        'brand-primary': vaporwave_color_1.default.violet,
        'brand-secondary': vaporwave_color_1.default.chartreuse,
        /* Theme Colors */
        black: vaporwave_color_1.default.black,
        white: vaporwave_color_1.default.white,
        text: vaporwave_color_1.default.black,
        /* System Colors */
        background: vaporwave_color_1.default.light.background,
        'background-secondary': vaporwave_color_1.default.light['background-secondary'],
        success: vaporwave_color_1.default.light.success,
        'success-bg': vaporwave_color_1.default.light['success-bg'],
        error: vaporwave_color_1.default.light.error,
        'error-bg': vaporwave_color_1.default.light['error-bg'],
        warning: vaporwave_color_1.default.light.warning,
        'warning-bg': vaporwave_color_1.default.light['warning-bg'],
        'divider-extra-light': vaporwave_color_1.default.light['divider-extra-light'],
        'divider-dark': vaporwave_color_1.default.light['divider-dark'],
        divider: vaporwave_color_1.default.light.divider,
        /* Scales */
        gray: vaporwave_color_1.default.light.gray[60],
        'gray-10': vaporwave_color_1.default.light.gray[10],
        'gray-20': vaporwave_color_1.default.light.gray[20],
        'gray-30': vaporwave_color_1.default.light.gray[30],
        'gray-40': vaporwave_color_1.default.light.gray[40],
        'gray-50': vaporwave_color_1.default.light.gray[50],
        'gray-60': vaporwave_color_1.default.light.gray[60],
        'gray-70': vaporwave_color_1.default.light.gray[70],
        'gray-80': vaporwave_color_1.default.light.gray[80],
        'gray-90': vaporwave_color_1.default.light.gray[90],
        'gray-100': vaporwave_color_1.default.light.gray[100],
        neutral: vaporwave_color_1.default.light.neutral[10],
        'neutral-10': vaporwave_color_1.default.light.neutral[10],
        'neutral-20': vaporwave_color_1.default.light.neutral[20],
        'neutral-30': vaporwave_color_1.default.light.neutral[30],
        'neutral-40': vaporwave_color_1.default.light.neutral[40],
        'neutral-50': vaporwave_color_1.default.light.neutral[50],
        'neutral-60': vaporwave_color_1.default.light.neutral[60],
        'neutral-70': vaporwave_color_1.default.light.neutral[70],
        'neutral-80': vaporwave_color_1.default.light.neutral[80],
        'neutral-90': vaporwave_color_1.default.light.neutral[90],
        'neutral-100': vaporwave_color_1.default.light.neutral[100],
        primary: vaporwave_color_1.default.light.purple[70],
        'primary-10': vaporwave_color_1.default.light.purple[10],
        'primary-20': vaporwave_color_1.default.light.purple[20],
        'primary-30': vaporwave_color_1.default.light.purple[30],
        'primary-40': vaporwave_color_1.default.light.purple[40],
        'primary-50': vaporwave_color_1.default.light.purple[50],
        'primary-60': vaporwave_color_1.default.light.purple[60],
        'primary-70': vaporwave_color_1.default.light.purple[70],
        'primary-80': vaporwave_color_1.default.light.purple[80],
        'primary-90': vaporwave_color_1.default.light.purple[90],
        'primary-100': vaporwave_color_1.default.light.purple[100],
        yellow: vaporwave_color_1.default.light.yellow[50],
        'yellow-10': vaporwave_color_1.default.light.yellow[10],
        'yellow-20': vaporwave_color_1.default.light.yellow[20],
        'yellow-30': vaporwave_color_1.default.light.yellow[30],
        'yellow-40': vaporwave_color_1.default.light.yellow[40],
        'yellow-50': vaporwave_color_1.default.light.yellow[50],
        'yellow-60': vaporwave_color_1.default.light.yellow[60],
        'yellow-70': vaporwave_color_1.default.light.yellow[70],
        'yellow-80': vaporwave_color_1.default.light.yellow[80],
        'yellow-90': vaporwave_color_1.default.light.yellow[90],
        'yellow-100': vaporwave_color_1.default.light.yellow[100],
        violet: vaporwave_color_1.default.violet,
        'violet-10': vaporwave_color_1.default.light.violet[10],
        'violet-20': vaporwave_color_1.default.light.violet[20],
        'violet-30': vaporwave_color_1.default.light.violet[30],
        'violet-50': vaporwave_color_1.default.light.violet[50],
        'violet-60': vaporwave_color_1.default.light.violet[60],
        'violet-70': vaporwave_color_1.default.light.violet[70],
        'violet-80': vaporwave_color_1.default.light.violet[80],
        'gradient-1': "linear-gradient(to right, ".concat(vaporwave_color_1.default.light.violet[60], " 0%, ").concat(vaporwave_color_1.default.light.violet[30], " 100%)"),
        'gradient-2': "linear-gradient(128deg, ".concat(vaporwave_color_1.default.light.violet[60], " -2.09%, ").concat(vaporwave_color_1.default.light.violet[30], " 107.82%)"),
        'red-70': vaporwave_color_1.default.light.red[70],
    },
    zIndices: {
        table: 1,
        pageCover: 999,
        popover: 1000,
        sidemenuOverlay: 1029,
        sidemenu: 1030,
        navbarOverlay: 1039,
        navbar: 1040,
        modal: 10000,
    },
    styles: {
        root: {
            fontFamily: 'body',
        },
    },
};
